import React from 'react';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';

import { getDeploymentDateTime, xlsxDownload, xlsxDownload2, xlsxDownload3, CSV, getPreciseTime } from '../../../Functions/utils';
import { useAppContext } from '../../../Context/App/Provider';

import { toast } from 'react-toastify';
import BeatLoader from 'react-spinners/BeatLoader';
import { colors, devicesTypeValues } from '../../../Shared/utils';

// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'


export default function ExportDeployments({  
  disabled, apiRef, loading, model, setModel, selectionModel, reportingColumns, getInterpretedData, label, labelLight, period, scenarioType,
  deployments, rows, settings, scenario, columns, uniqueCount
  })
  {
  const { t } = useTranslation();
  // const [{ settings }] = useAppContext();

  const excelDownload = () => {
    let start = getPreciseTime(period, 'start');
    let end = getPreciseTime(period, 'end');

    if (isNaN(start)) {
      start = 0;
    }
    if (isNaN(end)) {
      end = 0;
    }

    const startDateTmp = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
    const endDateTmp = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

    const values = selectionModel.length === 0 ? Array.from(apiRef.current.getVisibleRowModels().values()) : Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
    // console.log("23 - values=", values);

    let groupName = '~noname~';
    let groupCount = 0;
    for (const value of values) {
      if (groupName !== value.general_$$_group) {
        groupName = value.general_$$_group;
        groupCount++;
      }

      if (groupCount > 1)
        break;
    }

    // console.log("35 - groupCount=", groupCount);
    // console.log("36 - groupName=", groupName);
    let prefix = '';
    if (groupCount === 1)
      prefix = '(' + groupName + ')_';

    const date = getDeploymentDateTime();
    const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');

    const startDateTxt = startDateTmp.slice(0, 4) + startDateTmp.slice(5, 7) + startDateTmp.slice(8);
    const endDateTxt = endDateTmp.slice(0, 4) + endDateTmp.slice(5, 7) + endDateTmp.slice(8);

    const defaultFileName = prefix + t('reporting.export.filename', { date: fileDate }) + "_" + labelLight + "_" + startDateTxt + "-" + endDateTxt;

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('reporting.export.enter_filename'),
      input: "text",
      inputValue: defaultFileName,
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
  }
    }).then((value) => {
      // console.log("99 - value=", value);

      if (value && value.isConfirmed) {

        let inputFileName = (value && value.value !== "" ? value.value : defaultFileName)

        Swal.fire({
          allowOutsideClick: false,
          title: t('global.dialog_title'),
          html: t('reporting.export.in_progress'),
          showCancelButton: false,
          showConfirmButton: false,
          customClass: {
            confirmButton: 'confirm-button-class',
            title: 'title-class',
            icon: 'icon-class'
      }
        });
        processExcelDownload(inputFileName, scenarioType);
      };
    });
  }


      
  const processExcelDownload = async (inputFileName, scenarioType) => {

    // console.log("30 - processExcelDownload=", processExcelDownload);
      setTimeout(() => {
   
      Swal.update({
        html: t('reporting.export.in_progress') + t('reporting.export.gathering_data') + "...",
    });

      const values = selectionModel.length === 0 ? Array.from(apiRef.current.getVisibleRowModels().values()) : Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
    
        const options = {
          delimiter: '`'
        };

        let interpretedCsv = "";
        let newLine = "";

        // console.log("27 - ...getInterpretedData=", getInterpretedData);
        if (getInterpretedData) {

          for (const column of reportingColumns) {
            if (interpretedCsv)
              interpretedCsv = interpretedCsv + '`'

            interpretedCsv = interpretedCsv + column.headerName;
          }
          interpretedCsv = interpretedCsv + '\r\n';

        // console.log("43 - interpretedCsv=", interpretedCsv);
        // console.log("44 - reportingColumns=", reportingColumns);

          // for (const line of Array.from(apiRef.current.getEditRowsModel().values())) {
        for (const line of Array.from(values)) {
            newLine = "";

            // console.log("41 - ...line=", line);
            for (const column of reportingColumns) {
              const params = {
                formattedValue: line[column.field],
                field: column.field
          }
              // console.log("54 - params=", params);
            // const test = getInterpretedData(params);
              // console.log("57 - test=", test);

              if (newLine)
                newLine = newLine + '`'

              let newCell = "";
            const lines = getInterpretedData(params)

              for (const element of getInterpretedData(params)) {
                if (newCell)
                  newCell = newCell + ' / '

              if (element === ' ' && lines.length === 1)
                newCell = newCell + params.formattedValue;
              else
                newCell = newCell + element;
              }
              newLine = newLine + newCell;
        }
            interpretedCsv = interpretedCsv + newLine + '\r\n';
          }
        }       
      // console.log("72 - interpretedCsv=", interpretedCsv.length);
      // toast(t('004'), { type: 'success' })

        const csv = (interpretedCsv !== "") ? interpretedCsv : apiRef.current.getDataAsCsv(options);

      // console.log("93 - csv=", csv.length);

      // const date = getDeploymentDateTime();
      // const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');

        const printedColumns = [];
        for (let i = 0; i < reportingColumns.length; i++) {
        // const element = reportingColumns[i];
        // if (true || element.print === true) {
            printedColumns.push(i);
        // }
        }
      // console.log("85 - printedColumns=", printedColumns);

      xlsxDownload3({
          csv: csv,
          lang: settings.lang,
        filename: inputFileName, //t('reporting.export.filename', { date: fileDate }),
          dashboardText: t('global.dashboard'),
          printedColumns: printedColumns,
          period: settings.period,
          t,
        reportingColumns,
        label, 
        scenarioType ,
        
        deployments, rows, settings, scenario, columns, selectionModel, uniqueCount
        });
    }, 100);
      }



  const pdfDownload = () => {
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => {

        var generateData = function (amount) {
          var result = [];
          var data = {
            coin: "100",
            game_group: "GameGroup",
            game_name: "XPTO2",
            game_version: "25",
            machine: "20485861",
            vlt: "0"
          };
          for (var i = 0; i < amount; i += 1) {
            data.id = (i + 1).toString();
            result.push(Object.assign({}, data));
          }
          return result;
        };

        // console.log("62 - =", generateData(10));
        return;


        const date = getDeploymentDateTime();
        const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');
        const fileName = t('reporting.export.filename', { date: fileDate });

        const table = document.getElementById('print');


        const options = {
          delimiter: '`'
        };
        const csv = apiRef.current.getDataAsCsv(options);
        const parsed = CSV.parse(csv);


        let doc = new jsPDF('p', 'pt', 'A4');
        // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
        //doc.table(1, 1, generateData(100), headers, { autoSize: true });

        /*
        var generateData = function(amount) {
          var result = [];
          var data = {
            coin: "100",
            game_group: "GameGroup",
            game_name: "XPTO2",
            game_version: "25",
            machine: "20485861",
            vlt: "0"
          };
          for (var i = 0; i < amount; i += 1) {
            data.id = (i + 1).toString();
            result.push(Object.assign({}, data));
          }
          return result;
        };
        
        function createHeaders(keys) {
          var result = [];
          for (var i = 0; i < keys.length; i += 1) {
            result.push({
              id: keys[i],
              name: keys[i],
              prompt: keys[i],
              width: 65,
              align: "center",
              padding: 0
            });
          }
          return result;
        }
        
        var headers = createHeaders([
          "id",
          "coin",
          "game_group",
          "game_name",
          "game_version",
          "machine",
          "vlt"
        ]);        
        
        var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
        doc.table(1, 1, generateData(100), headers, { autoSize: true });

        */



        // doc.html(table, {
        //   margin: 20,
        //   elementHandlers: () => true,
        //   html2canvas: html2canvas(table),
        //   callback: (doc) => doc.save(fileName + '.pdf')
        // });
      }
    )
  };

  return (
    <>
      <button
        disabled={loading || disabled}
        onClick={() => {
          excelDownload()
        }}
        className="button icon"
        title={t('global.actions.xlsx')}
      >
        <span className="material-icons-round">table_view</span>
      </button>

      <button style={{ display: 'none' }}
        disabled={loading}
        onClick={pdfDownload}
        className="button icon"
        title={t('global.actions.pdf')}
      >
        <span className="material-icons-round" style={{ fontSize: '28px' }}>picture_as_pdf</span>
      </button>
    </>
  );
}
